import { environment } from 'src/environments/environment';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { BRANDING_CONFIG } from '../core/constants/branding.constants';

export function MsalInstanceFactory(): IPublicClientApplication {
  const clientId = BRANDING_CONFIG?.AZURE_CLIENT_ID?.trim() || environment.azureClientId;
  const authority = BRANDING_CONFIG?.AZURE_AUTHORITY?.trim() || environment.azureAuthority;
  const redirectUri = BRANDING_CONFIG?.AZURE_REDIRECT_URL?.trim() || environment.azureRedirectUrl;

  return new PublicClientApplication({
    auth: {
      clientId,
      authority,
      redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  });
}
